/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

const savedScrollPositions = new Map();

exports.onPreRouteUpdate = ({ prevLocation }) => {
	if (prevLocation) {
		savedScrollPositions.set(prevLocation.pathname + prevLocation.search, [
			window.scrollX,
			window.scrollY,
		]);
	}
};

// Wait for page height to stabilize before restoring scroll.
// Lazy-loaded (ssr:false) components like Hero (min-height:90vh) render as
// null initially, so scroll must be deferred until layout is fully settled.
function restoreWhenStable(position, prevHeight, stableFrames, attempts) {
	if (attempts > 30 || stableFrames >= 3) {
		window.scrollTo(...position);
		return;
	}
	requestAnimationFrame(() => {
		const h = document.documentElement.scrollHeight;
		if (h === prevHeight) {
			restoreWhenStable(position, h, stableFrames + 1, attempts + 1);
		} else {
			restoreWhenStable(position, h, 0, attempts + 1);
		}
	});
}

exports.shouldUpdateScroll = ({ routerProps: { location }, getSavedScrollPosition }) => {
	// In Gatsby 5, back/forward navigation arrives with action === undefined (not 'POP')
	const isBackForward = !location.action || location.action === 'POP';
	if (isBackForward) {
		const key = location.pathname + location.search;
		const position =
			savedScrollPositions.get(key) || getSavedScrollPosition(location);
		if (position) {
			restoreWhenStable(position, -1, 0, 0);
			return false;
		}
	}
	return true;
};
